module.exports = `
<div v-if="dataisload">
    <div class="ig-wrap clearfix">
	    <div class="ig-row clearfix">
		    <div class="ig-box-c ig-container">
		    	<div v-for="(item, index) in pagePosts" :style="'width:'+((index+1) % 18 === 7 || (index+1) % 18 === 16 ? refinedH:refinedH/2)+'px'" class="ig-box" :class="{'ig-box-l': (index+1) % 18 === 7 || (index+1) % 18 === 16, 'put-right': (index+1) % 18 === 16}">
				    <div class="ig-img" @click.prevent="openPopup(index, item.ID)">
				        <div class="ig-mask">
				        	<i class="icon-ig2-white"></i>
				        	<span class="d-inline-block ml-2">{{item.Owner.UserName}}</span>
				        </div>
				        <div class="ig-img-box" :style="'background-image: url('+item.Cover+');'"></div>
				    </div>
				</div>
		    </div>
	    </div>
    </div>

    <ig-popup :item="popupPost" :isopen="popupIsOpen" :stop="scrollY" v-on:close="closePopup" v-on:gopost="changeNowIndex" />
<div>
`;
